import TypographyUseOfTypeScreen from './TypographyUseOfTypeScreen'

export default TypographyUseOfTypeScreen
